import { sclixSaleAbi } from "./contractAbi/SClixSale";

export default {
  sclixSaleAddress: "0x002D1C30E08c7c13C15488fa5A1C11c23323D65a",
  allowedChainId: "56",

  sclixSaleAbi: sclixSaleAbi,
};
